<template>
  <b-modal
    :id="id"
    size="xl"
    title="Submit for Approval"
    ok-title="Submit"
    @ok="onSubmit"
    @show="onShow">
    <b-container fluid>
      <b-row>
        <b-col cols="9">
          <b-card
            no-body
            hide-header>
            <div class="acediff" />
          </b-card>
        </b-col>
        <b-col>
          <b-card header="Details">
            <div class="bg-warning mb-2">
              <strong>Changes to be Applied: </strong>{{ numDiffChanges }}
            </div>
            <div class="mb-2">
              <strong>Major Version: </strong>{{ fileDetails.major.version }}
            </div>
            <div
              v-if="overrideId"
              class="mb-2">
              <strong>Minor Version: </strong>{{ fileDetails.minor.version }}
            </div>
            <div class="mb-2">
              <strong>File Name: </strong>{{ fileName }}
            </div>
            <div v-if="!overrideId">
              <strong>All Versions Affected</strong>
              <ul>
                <li
                  v-for="version in versionsAffected"
                  :key="version">
                  {{ version }}
                </li>
              </ul>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
  import { Approval, Config } from '@/services/api'
  import AceDiff from 'ace-diff'
  import { patch } from 'jsondiffpatch'

  export default {
    name: "SubmitApprovalModal",
    props: {
      id: {
        type: String,
        required: true,
      },
      fileDetails: {
        type: Object,
        required: false,
        default: null,
      },
      fileId: {
        type: Number,
        required: true,
      },
      fileName: {
        type: String,
        required: false,
        default: null,
      },
      overrideId: {
        type: Number,
        required: false,
        default: null,
      },
      originalJson: {
        type: Object,
        required: false,
        default: null,
      },
      jsonDiff: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        versionsAffected: null,
        aceDiff: null,
        numDiffChanges: null,
      }
    },
    methods: {
      async onSubmit() {
        await Approval.create(this.jsonDiff, this.fileId, this.overrideId)
        this.$bus.$emit('refresh-approvals')
        this.$router.push('/')
      },
      async onShow() {
        if (!this.overrideId) {
          const configs = await Config.configs(this.fileDetails.platform.id)
          this.versionsAffected = configs.find(c => c.id === this.fileDetails.major.id).minors.map(m => m.version)
        }
        let patchedJSON = JSON.parse(JSON.stringify(this.originalJson))
        patch(patchedJSON, this.jsonDiff)
        this.aceDiff = new AceDiff({
          element: '.acediff',
          left: {
            content: JSON.stringify(this.originalJson, null, 2),
            editable: false,
            copyLinkEnabled: false,
          },
          right: {
            content: JSON.stringify(patchedJSON, null, 2),
            editable: false,
            copyLinkEnabled: false,
          },
        })

        // required as a timeout because of the setTimeout by aceDiff
        setTimeout(() => {
          this.numDiffChanges = this.aceDiff.getNumDiffs()
        }, 100)
      },
    },
  }
</script>

<style>
  @import '~ace-diff/dist/ace-diff.min.css';

  .acediff {
    overflow: auto;
    min-height: 600px;
    position: relative;
  }

  @media (min-width: 1200px) {
    .modal-xl {
      width: 95%;
      max-width: 1600px;
      min-height: 600px;
    }
  }

</style>